import { Component, EventEmitter, Input, forwardRef, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { AnagraficaIndirizziService } from 'src/app/core/anagrafica-indirizzi.service';
import { Indirizzo } from 'src/app/shared/models/indirizzo.model';

@Component({
  selector: 'app-dati-documento-mittente',
  template: `
    <div class="mittente-container">
      <div class="mittente-autocomplete">
        <p-autoComplete
          [forceSelection]="false"
          [appAnagraficaAutocomplete]="AnagraficaIndirizziService"
          [style]="{ 'width': '100%' }"
          [ngModel]="mittenteIdSelected"
          (onClear)="mittenteSelected(null)"
          (onSelect)="mittenteSelected($event.value)"
          (unmatchedValue)="newMittenteChanged($event)"
          (anagraficaItemsChanged)="itemsChanged($event)">
        </p-autoComplete>
      </div>

      @if (showNuovoSoggettoButton) {
        <button
          pButton
          type="button"
          icon="fas fa-plus"
          title="Nuovo Soggetto"
          (click)="openSoggettoDialog()"
          novalidate></button>
      }
    </div>
    @if (newMittente && showNuovoSoggettoButton) {
      <small>Clicca + per aprire la modale di creazione soggetto</small>
    }
    `,
  styles: [
    `
      :host ::ng-deep .p-picklist .p-picklist-list { width: auto; }
      .mittente-container { display: flex; gap: 0.5rem; align-items: center; }
      .mittente-autocomplete { flex: 1; min-width: 0; }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MittenteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MittenteComponent),
      multi: true
    }
  ]
})
export class MittenteComponent implements ControlValueAccessor, Validator {
  @Input() public showNuovoSoggettoButton = false;
  @Output() public openNuovoSoggettoDialog = new EventEmitter<void>();
  public mittenteIdSelected: Indirizzo | null | undefined;
  public newMittente: string | undefined;
  public AnagraficaIndirizziService = AnagraficaIndirizziService;

  private onChangeFn!: (_: unknown) => void;
  private onTouchedFn!: () => void;

  writeValue(value: Indirizzo): void {
    this.mittenteIdSelected = value;
  }

  registerOnChange(fn: (_: unknown) => void): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedFn = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value as number;
    if (value) {
      return null;
    } else if (!this.newMittente) {
      return { required: true };
    } else {
      return { mustCreate: true };
    }
  }

  mittenteSelected(value: Indirizzo | null): void {
    this.mittenteIdSelected = value;
    delete this.newMittente;
    this.onChangeFn(value);
  }

  newMittenteChanged(value: string): void {
    this.newMittente = value;
    this.onChangeFn(null);
  }

  openSoggettoDialog(): void {
    this.openNuovoSoggettoDialog.emit();
  }

  itemsChanged(indirizzi: Indirizzo[]): void {
    if (this.newMittente) {
      this.mittenteIdSelected = indirizzi.find(i => i.nomeIndirizzo === this.newMittente);
      delete this.newMittente;
      this.onChangeFn(this.mittenteIdSelected);
    }
  }
}
